import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { LONG_WRITE_TIMEOUT_MS } from "@/utils/axios-client";
import { OrderSheetTab } from "@/features/order-sheets/order-sheet.type";
import { OrderSheetRevision } from "@/features/order-sheet-sets/order-sheet-revision.type";
import { CompanyType } from "@/features/types";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";

export interface CreateOrderSheetRevisionV2Request {
  orderSheetTabs: OrderSheetTab[];
}

export interface CreateOrderSheetRevisionV2Response extends OrderSheetRevision {}

export interface CreateOrderSheetRevisionV2PathParameter {
  by: CompanyType;
  companyId: number;
  orderSheetSetId: number;
}

export const createOrderSheetRevisionV2TemplateUrl = `/:by/:companyId/order-sheet-sets/:orderSheetSetId/revisions`;

export const createOrderSheetRevisionV2Key: YWRKey<CreateOrderSheetRevisionV2PathParameter> =
  {
    url: (parameter) => {
      return calcUrl(createOrderSheetRevisionV2TemplateUrl, parameter);
    },
    method: "post",
  };

export default function useCreateOrderSheetRevisionV2() {
  const fetcher = useFetcher<
    CreateOrderSheetRevisionV2Request,
    CreateOrderSheetRevisionV2Response
  >();
  // 오더시트 저장은 탭·상품 수에 따라 30초를 넘길 수 있다 — 기본 타임아웃(30초)에 잘리지 않게.
  return useYWR(createOrderSheetRevisionV2Key, fetcher, {
    timeout: LONG_WRITE_TIMEOUT_MS,
  });
}
